import type { User } from '@awork/features/user/models/user.model'
import type { AccessLevels } from '@awork/features/workspace/models/permissions.model'

interface IFilterContributor {
  id: string
  userId: string
  accessLevel: AccessLevels
  user?: User
}

/**
 * The filter contributor model
 */
export class FilterContributor implements IFilterContributor {
  id: string
  userId: string
  accessLevel: AccessLevels
  user?: User

  constructor(filterContributor: Partial<IFilterContributor>) {
    Object.assign(this, filterContributor)
  }
}
